import React, { lazy, Suspense, useEffect, useState } from 'react'
import useAuth from '../../../hooks/useAuth';
import "./Dashboard.css";
import Alert from '../../HtmlElements/Alert';
import { useUser } from '../../../context/UserContext';
import { useLocation, useParams } from 'react-router-dom';
import { getUrlDetailsObj, getUserStatsObject, recordActivity } from '../../../services/commonService';
import EventsWrappers from '../wrappers/eventsWrappers';
import { useDispatch } from 'react-redux';
import { getCheckoutClientInfo } from "../../../services/authService";
import { fetchClientNudgeRequest } from '../../../store/features/actions/clientNudgeActions';
import { resetAllAccDepen } from '../../../store/features/actions/commonActions';
const ClientsNudges = lazy(() => import("./ClientsNudges"));
const FavouriteAccounts = lazy(() => import("./FavouriteAccounts"));
<link href="https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap" rel="stylesheet"/>

export default function Dashboard() {
 useAuth(); // Ensure the user is authenticated 

var currentUrl = useLocation().pathname;
const pageParsedData = getUrlDetailsObj(useLocation, useParams);

useEffect(() => {
  //On loading dashboard
  const userStat = getUserStatsObject("Dashboard", "page_load", "Page Source: Dashboard", currentUrl);
  userStat.url_details = pageParsedData;
  recordActivity(userStat);
}, []);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(10);
  const [sortField, setSortField] = useState("publishedAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [filter, setFilter] = useState({ title: "", types: "", regions: "" });
 const [errorMessage, setErrorMessage] = useState('');
 const { user } = useUser();
  const {checkoutClientName} = getCheckoutClientInfo();
  const clientNameNew = checkoutClientName || (user?.company_name || '');

 useEffect(() => {
    dispatch(resetAllAccDepen())
    let errorMessage = sessionStorage.getItem('errorMessage');
    if (errorMessage) {
      setErrorMessage(errorMessage);
      sessionStorage.removeItem('errorMessage'); // Clear the message
    }
    if(clientNameNew){
      dispatch(fetchClientNudgeRequest({clientNameNew}))
    }
   
  }, [clientNameNew]);

  return (
    <div>
      <div className="container-fluid">
        {errorMessage && (
          <div className="row">
            <div className="col-md-12 mt-3">
              <Alert type="danger" message={errorMessage} />{" "}
            </div>
          </div>
        )}

        <div className="row">
          <EventsWrappers
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            perPage={perPage}
            sortField={sortField}
            setSortField={setSortField}
            sortOrder={sortOrder}
            setSortOrder={setSortOrder}
            filter={filter}
            setFilter={setFilter}
          />
        </div>
        <div className="row">
          <div className="col-md-7">
            <div className="custom_card_block">
              <Suspense fallback={null}>
                <ClientsNudges />
              </Suspense>
            </div>
          </div>
          <div className="col-md-5">
            <div className="custom_card_block">
              <Suspense fallback={null}>
                <FavouriteAccounts />
              </Suspense>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
